export enum SummerAppFieldsValidators{
    Name="Name",
    SSN='SSN',
    Zip='Zip Code',
    DateOfBirth="Date Of Birth",
    PhoneNumber="US Phone Number",
    MiddleInitial="Middle Initial",
    RefferalCode="Referral Code"
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/fields-validators.enum.ts